import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequestHeader } from '@tanstack/react-start/server'
import { CLERK_MOUNT_ATTRIBUTE, shouldMountClerk } from './clerk-mount'

/**
 * Should this document mount the Clerk runtime?
 *
 * - Server (SSR): decided from the path + the REQUEST's cookie header.
 * - Browser: reads the server's decision back from `<html data-clerk>`, so
 *   hydration renders exactly the tree the server rendered, even if a cookie
 *   changed in between.
 */
export const resolveClerkMount = createIsomorphicFn()
  .server((pathname: string) =>
    shouldMountClerk(pathname, getRequestHeader('cookie') ?? ''),
  )
  .client(
    (_pathname: string) =>
      document.documentElement.getAttribute(CLERK_MOUNT_ATTRIBUTE) === '1',
  )
